export default __webpack_public_path__ + "c36abfdcf6f94a1b0761508625872b08.svg";